<div class="success-container">
  <div class="success-content">
    @switch (subscriptionStatus$ | async) {
      @case ('processing') {
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Activating...</span>
        </div>
        <h1>Starting Your Trial...</h1>
        <p>Please wait while we set up your account.</p>
      }
      @case ('success') {
        <h1>Your Trial Has Started!</h1>
        <p>
          Welcome to ClassJax! You have full access for 14 days.
          Your card will be charged when the trial ends.
        </p>
        <div class="actions">
          <button (click)="navigateToHome()" class="primary-button">
            Get Started
          </button>
        </div>
      }
      @case ('error') {
        <h1>Something went wrong</h1>
        <p>
          We couldn't confirm your subscription. If you were charged, please
          contact support.
        </p>
        <div class="actions">
          <button (click)="navigateToHome()" class="primary-button">
            Go to Dashboard
          </button>
        </div>
      }
    }
  </div>
</div>
